import { render } from "./AgeGenderCard.vue?vue&type=template&id=0641a65a&scoped=true"
import script from "./AgeGenderCard.vue?vue&type=script&lang=js"
export * from "./AgeGenderCard.vue?vue&type=script&lang=js"

import "./AgeGenderCard.vue?vue&type=style&index=0&id=0641a65a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0641a65a"]])

export default __exports__